var exports = {
  "kL": "xcc377c0b--20c375--container",
  "wx": "xcc377c0b--20c375--header",
  "aw": "xcc377c0b--20c375--slider",
};

module.exports = exports;
